import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import DefaultPageWrapper from "../../components/wrapper/DefaultPageWrapper";
import { USER_ROLES } from "../../helpers/constants";
import { useAccessControl } from "../../hooks/auth/useCheckPermission";
import { InvestmentManagementTab } from "./InvestmentsTabs/InvestmentManagementTab";
import { MassNotificationsTab } from "./InvestmentsTabs/MassNotificationsTab";
import { ProductTypesManagementTab } from "./InvestmentsTabs/ProductTypesManagementTab";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

export function SalesInvestmentPage() {
    const { t } = useTranslation();
    const [tabValue, setTabValue] = useState(0);

    const { hasAccess } = useAccessControl([USER_ROLES.ADMIN, USER_ROLES.SALES_MANAGER]);

    if (!hasAccess) {
        return null;
    }

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        // @ts-ignore
        <DefaultPageWrapper tagTitle={t("products.SalesInvestmentPage.pageTitle")}>
            <Box sx={{ width: "100%" }}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        aria-label="sales investment tabs"
                    >
                        <Tab
                            label={t("products.SalesInvestmentPage.investmentManagement")}
                            {...a11yProps(0)}
                            sx={{ fontSize: "1.1rem" }}
                        />
                        <Tab
                            label={t("products.SalesInvestmentPage.productTypesManagement")}
                            {...a11yProps(1)}
                            sx={{ fontSize: "1.1rem" }}
                        />
                        <Tab
                            label={t("products.SalesInvestmentPage.massNotifications")}
                            {...a11yProps(2)}
                            sx={{ fontSize: "1.1rem" }}
                        />
                    </Tabs>
                </Box>
                <TabPanel value={tabValue} index={0}>
                    <InvestmentManagementTab />
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                    <ProductTypesManagementTab />
                </TabPanel>
                <TabPanel value={tabValue} index={2}>
                    <MassNotificationsTab />
                </TabPanel>
            </Box>
        </DefaultPageWrapper>
    );
}
